export const WEBVIEW = {
    ORIGIN_TYPE: 'webview_origin',
};